import styled from 'styled-components'
import { VStack } from '../../../global/styles'

export const QuestionsWrap = styled(VStack)``
export default QuestionsWrap
